export default function Settings() {

  return <div className="Settings">Settings</div>;
}